import React, {useEffect, useState} from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/Hiring.css";
import {
    badge,
    maternity,
    note,
    shelterCopy,
    singleProfile,
} from "../../Constant";
import moment from "moment";
import {Calendar, momentLocalizer} from "react-big-calendar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faAdd,
    faCheckCircle,
    faClose,
} from "@fortawesome/free-solid-svg-icons";
import {connect} from "react-redux";
import {Link, useNavigate, useParams} from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import GoogleMapsReact from "google-map-react";
import {START_LOADER, STOP_LOADER} from "../../redux/actions/types";

const useForceUpdate = () => {
    const [value, setValue] = useState(0); // integer state
    return () => setValue((value) => value + 1); // update state to force render
    // An function that increment 👆🏻 the previous state like here
    // is better than directly setting `value + 1`
};

const Hiring = ({auth, services, startLoading, stopLoading}) => {
    const forceUpdate = useForceUpdate();

    const navigate = useNavigate();

    const localization = momentLocalizer(moment);

    const {service_id, care_giver_id} = useParams();

    const [loading, setLoading] = useState(true);

    const [serviceId, setServiceId] = useState(0);
    const [often, setOften] = useState("one");
    const [fullName, setFullname] = useState("");
    const [gender, setGender] = useState("Male");
    const [clientIdentity, setClientIdentity] = useState("");
    const [title, setTitle] = useState("");
    const [noteText, setNoteText] = useState("");
    const [age, setAge] = useState("");
    const [agree, setAgree] = useState(false);

    const [selectedService, setSelectedService] = useState(null);
    const [selectedServiceSchedule, setSelectedServiceSchedule] = useState([]);

    // Once Schedule Fields
    const [oneSchedule, setOneSchedule] = useState({
        // [moment().format("YYYY-MM-DD")]: [{ start_time: "", end_time: "" }],
    });

    // Weekly Fields
    const [weeklySchedule, setWeeklySchedule] = useState({
        // [moment().format("dddd")]: [{ start_time: "", end_time: "" }],
    });
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [careGiver, setCareGiver] = useState();

    useEffect(() => {
        if (!auth.user.address_1) {
            Swal.fire({
                icon: "info",
                title: "Update Address",
                text: "You need to update your address before proceeding to hire anyone!",
            }).then(() => {
                navigate("/edit-profile");
            });
        }
        getUser();
        // setServiceId(0);
    }, []);

    useEffect(() => {
        setOneSchedule({});
        setWeeklySchedule({});
        if (careGiver && careGiver.services) {
            let singleService = careGiver.services.filter(
                (service) => service.service_id == serviceId
            );
            let serviceSchedule = careGiver.schedule.filter(
                (singleSchedule) => singleSchedule.service_id == serviceId
            );
            let serviceScheduleDays = serviceSchedule.map(
                (singleServiceSchedule) => singleServiceSchedule.availability
            );
            if (singleService.length > 0) {
                setSelectedService(singleService[0]);
                setSelectedServiceSchedule(serviceScheduleDays);
            }
        }
    }, [serviceId]);

    const getUser = async () => {
        const res = await config.getApi(
            config.services.singleCareGiver(care_giver_id),
            config.bearerHeaders(auth.token)
        );
        if (res) {
            console.log("setCareGiver", res.response.data);
            setCareGiver(res.response.data);

            // setTimeout(() => {
            //     console.log(service_id);
            //     setServiceId(service_id);
            //     forceUpdate();
            // }, 1000);

            // setServiceId(service_id);
            setLoading(false);

            // setTimeout(() => {
            // console.log(service_id);
            setServiceId(service_id);
            // forceUpdate();
            // }, 1000);
        }
    };

    const addSchedule = (type, start) => {
        console.log("oneSchedulee", type, start);
        if (type == "one") {
            let oneSchedulee = {
                ...oneSchedule,
            };
            if (oneSchedulee[moment(start).format("YYYY-MM-DD")]) {
                delete oneSchedulee[moment(start).format("YYYY-MM-DD")];
            } else {
                oneSchedulee[moment(start).format("YYYY-MM-DD")] = [
                    {
                        start_time: "",
                        end_time: "",
                    },
                ];
            }
            setOneSchedule(oneSchedulee);
        } else {
            let weeklySchedulee = {
                ...weeklySchedule,
            };
            if (weeklySchedulee[start]) {
                delete weeklySchedulee[start];
            } else {
                weeklySchedulee[start] = [
                    {
                        start_time: "",
                        end_time: "",
                    },
                ];
            }
            setWeeklySchedule(weeklySchedulee);
        }
    };

    const addMoreVisit = (type, scheduleDate) => {
        if (type == "one") {
            let oneSchedulee = {...oneSchedule};
            oneSchedulee[scheduleDate].push({
                start_time: "",
                end_time: "",
            });
            setOneSchedule(oneSchedulee);
        } else {
            let weeklySchedulee = {...weeklySchedule};
            weeklySchedulee[scheduleDate].push({
                start_time: "",
                end_time: "",
            });
            setWeeklySchedule(weeklySchedulee);
        }
    };

    const onStartTimeChange = (type, scheduleDate, index, start_time) => {
        if (type == "one") {
            let oneSchedulee = {
                ...oneSchedule,
            };
            oneSchedulee[scheduleDate][index].start_time = start_time;
            setOneSchedule(oneSchedulee);
        } else {
            let weeklySchedulee = {
                ...weeklySchedule,
            };
            weeklySchedulee[scheduleDate][index].start_time = start_time;
            setWeeklySchedule(weeklySchedulee);
        }
    };

    const onEndTimeChange = (type, scheduleDate, index, end_time) => {
        if (type == "one") {
            let oneSchedulee = {
                ...oneSchedule,
            };
            oneSchedulee[scheduleDate][index].end_time = end_time;
            setOneSchedule(oneSchedulee);
        } else {
            let weeklySchedulee = {
                ...weeklySchedule,
            };
            weeklySchedulee[scheduleDate][index].end_time = end_time;
            setWeeklySchedule(weeklySchedulee);
        }
    };

    const removeVisit = (type, scheduleDate, index) => {
        if (type == "one") {
            let oneSchedulee = {...oneSchedule};
            delete oneSchedulee[scheduleDate][index];
            setOneSchedule(oneSchedulee);
        } else {
            let weeklySchedulee = {...weeklySchedule};
            delete weeklySchedulee[scheduleDate][index];
            setWeeklySchedule(weeklySchedulee);
        }
    };

    const submit = async (e) => {
        try {
            e.preventDefault();
            if (!agree) {
                return Swal.fire({
                    icon: "warning",
                    title: "Privacy Policy",
                    text: "You must agree Privacy Policy in order to book the job!",
                });
            }
            startLoading();
            const headers = config.bearerHeaders(auth.token);
            let dataa = {
                care_giver_id: care_giver_id,
                service_id: serviceId,
                destination_address: auth.user.address_1,
                destination_lat: auth.user.lat,
                destination_lng: auth.user.lng,
                often: often,
                full_name: fullName,
                gender: gender,
                client_identity: clientIdentity,
                title: title,
                note: noteText,
                age: age,
            };
            // console.log(dataa);
            // let formData = new FormData();
            // formData.append("care_giver_id", care_giver_id);
            // formData.append("service_id", serviceId);
            // formData.append("destination_address", auth.user.destination_address);
            // formData.append("destination_lat", auth.user.destination_lat);
            // formData.append("destination_lng", auth.user.destination_lng);
            // formData.append("often", often);
            // formData.append("full_name", fullName);
            // formData.append("gender", gender);
            // formData.append("client_identity", clientIdentity);
            // formData.append("title", title);
            // formData.append("note", note);
            // formData.append("age", age);
            let schedule = [];
            if (often == "one") {
                Object.keys(oneSchedule).map((scheduleDate) => {
                    oneSchedule[scheduleDate].map((visit) => {
                        schedule.push({
                            date: scheduleDate,
                            start_time: visit.start_time,
                            end_time: visit.end_time,
                        });
                    });
                });
            } else {
                let days = [];
                dataa["weekly_start_date"] = startDate;
                dataa["weekly_end_date"] = endDate;
                // formData.append("weekly_start_date", startDate);
                // formData.append("weekly_end_date", endDate);
                Object.keys(weeklySchedule).map((day) => {
                    days.push(day);
                    weeklySchedule[day].map((visit) => {
                        schedule.push({
                            date: day,
                            start_time: visit.start_time,
                            end_time: visit.end_time,
                        });
                    });
                });
                dataa["weekly_days"] = days;
                // formData.append("weekly_days", days);
            }
            // console.log(schedule);
            dataa["schedule"] = schedule;
            // formData.append("schedule[]", schedule);
            const res = await config.postApi(
                config.services.bookJob(),
                headers,
                JSON.stringify(dataa)
            );
            stopLoading();
            if (res) {
                Swal.fire({
                    title: "Success",
                    text: "Job Booked Successfully!",
                    icon: "success",
                }).then((value) => {
                    navigate("/all-booking");
                    // console.log(value);
                    // if(value.isConfirmed)
                });
                // console.log(res);
            }
        } catch (e) {
            console.log(e);
            throw stopLoading();
        }
    };

    if (loading) {
        return <div/>;
    }

    console.log("event",careGiver,
        // (serviceId ? serviceId : service_id),
        // typeof  (serviceId ? serviceId : service_id) ,careGiver.calendar,
        [
        ...careGiver.calendar.filter((singleCalendar) => {
            // console.log(
            //     singleCalendar.service_id.find( (value) => value === parseInt(serviceId ? serviceId : service_id))
            // );
            return singleCalendar.service_id.find( (value) => value === parseInt(serviceId ? serviceId : service_id));
        })
    ]);

    return (
        <>
            <Header/>
            {/* <!-- Hiring Section Start Here --> */}
            <section className="hiring_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            {/* <div className="note">
                                <figure>
                                    <img src={note} alt="" />
                                </figure>{" "}
                                Your Total bill will be charged automatically on
                                acceptance of this application by{" "}
                                <a href="#">{}</a>
                            </div> */}
                            <div className="heading_wrapper">
                                <h4>
                                    Hiring{" "}
                                    <span className="user_name">
                                        {careGiver.full_name}
                                    </span>
                                </h4>
                                <p>
                                    Choose from the selection of services, how
                                    often you need them, and mention other
                                    preferences for a quick process.
                                </p>
                            </div>
                            <form action="" method="post" onSubmit={submit}>
                                <div className="select_service">
                                    <div className="heading">
                                        <h5>Select Service</h5>
                                    </div>
                                    <ul className="services">
                                        {careGiver.services.map((service) => (
                                            <li
                                                key={service.service_id.toString()}
                                                onClick={() => {
                                                    // console.log(
                                                    //     service.service_id
                                                    // );
                                                    setServiceId(
                                                        service.service_id
                                                    );
                                                }}
                                            >
                                                {/* <div className="service_box"> */}
                                                <label className="service-container">
                                                    <input
                                                        value={
                                                            service.service_id
                                                        }
                                                        type="radio"
                                                        checked={
                                                            serviceId ==
                                                            service.service_id
                                                                ? true
                                                                : false
                                                        }
                                                        name="service_id"
                                                        // onChange={(e) => {
                                                        //     console.log(
                                                        //         e.target.value
                                                        //     );
                                                        //     setServiceId(
                                                        //         e.target.value
                                                        //     );
                                                        // }}
                                                    />
                                                    <span className="checkmark">
                                                        <div className="care_box">
                                                            <div className="check_icon">
                                                                {/* <FontAwesomeIcon
                                                                    icon={
                                                                        faCheckCircle
                                                                    }
                                                                /> */}
                                                            </div>
                                                            <div className="img_box">
                                                                <figure>
                                                                    <img
                                                                        src={
                                                                            config.assetUrl +
                                                                            "uploads/" +
                                                                            service
                                                                                .service
                                                                                .image
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </figure>
                                                            </div>
                                                            <div className="title">
                                                                <h5>
                                                                    {
                                                                        service
                                                                            .service
                                                                            .title
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </label>
                                                {/* </div> */}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="often_need">
                                    <div className="heading">
                                        <h5>
                                            How often do you need this service?
                                        </h5>
                                    </div>
                                    <ul className="service_time">
                                        <li>
                                            <label
                                                className="how_often_container"
                                                htmlFor="one_often"
                                            >
                                                One Time
                                                <input
                                                    type="radio"
                                                    id="one_often"
                                                    checked={
                                                        often == "one"
                                                            ? true
                                                            : false
                                                    }
                                                    name="timeradio"
                                                    value={"one"}
                                                    onChange={(e) =>
                                                        setOften(e.target.value)
                                                    }
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label
                                                className="how_often_container"
                                                htmlFor="weekly_often"
                                            >
                                                Weekly
                                                <input
                                                    type="radio"
                                                    id="weekly_often"
                                                    checked={
                                                        often == "weekly"
                                                            ? true
                                                            : false
                                                    }
                                                    name="timeradio"
                                                    value={"weekly"}
                                                    onChange={(e) =>
                                                        setOften(e.target.value)
                                                    }
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div className="select_dates">
                                    <h4>Select Dates</h4>
                                </div>
                                <div
                                    className={`select_date_calender ${
                                        often == "one" ? "show" : ""
                                    }`}
                                >
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="calendar-container">
                                                <Calendar
                                                    components={{
                                                        eventWrapper: ({event, children}) => {
                                                            if (
                                                                event.available
                                                            ) {
                                                                return (
                                                                    <div
                                                                        style={{
                                                                            height: 4,
                                                                            width: "100%",
                                                                            background:
                                                                                event.color ===
                                                                                "orange"
                                                                                    ? config.primaryColor
                                                                                    : "black",
                                                                        }}
                                                                    />
                                                                );
                                                            } else {
                                                                return (
                                                                    <div
                                                                        style={{
                                                                            height: 4,
                                                                            width: "100%",
                                                                            background:
                                                                                "#3174ad",
                                                                        }}
                                                                    />
                                                                );
                                                            }
                                                        },
                                                    }}
                                                    selectable={true}
                                                    views={["month"]}
                                                    localizer={localization}
                                                    style={{
                                                        height: 300,
                                                        width: "100%",
                                                    }}
                                                    events={[
                                                        ...[
                                                            ...careGiver.calendar.filter(
                                                                (
                                                                    singleCalendar
                                                                ) =>
                                                                    singleCalendar.service_id.
                                                                    // .includes(
                                                                    //     serviceId
                                                                    //         ? serviceId
                                                                    //         : service_id
                                                                    // )
                                                                    find( (value) => value === parseInt(serviceId ? serviceId : service_id))
                                                            ),
                                                        ],
                                                        ...Object.keys(
                                                            oneSchedule
                                                        ).map(
                                                            (scheduleDate) => {
                                                                return {
                                                                    start: scheduleDate,
                                                                    end: scheduleDate,
                                                                };
                                                            }
                                                        ),
                                                    ]}
                                                    onSelectSlot={({
                                                                       action,
                                                                       start,
                                                                   }) => {
                                                        if (selectedServiceSchedule.includes(
                                                                moment(start)
                                                                    .format(
                                                                        "dddd"
                                                                    )
                                                                    .toLowerCase()
                                                            ) &&
                                                            moment(start).diff(
                                                                moment(),
                                                                "days"
                                                            ) >= 0
                                                        ) {
                                                            addSchedule(
                                                                "one",
                                                                start
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>

                                            <div className="availabiltyDv">
                                                <div className="available check_availabilty">
                                        <span
                                            className="color"
                                            style={{
                                                backgroundColor: "#ff5735",
                                            }}
                                        ></span>
                                                    <p>Available</p>
                                                </div>
                                                <div className="not_available check_availabilty">
                                        <span
                                            className="color"
                                            style={{backgroundColor: "#000"}}
                                        ></span>
                                                    <p>Not Available</p>
                                                </div>
                                            </div>

                                            {/* <section className="calendar">
                                                <div id="datepicker_scnd"></div>
                                                <div className="datepicker-footer">
                                                    Last updated on{" "}
                                                    <span className="colored">
                                                        August 7 2021
                                                    </span>
                                                </div>
                                            </section> */}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="noteDv">
                                                <p>
                                                    <span className="bold">
                                                        Note:
                                                    </span>{" "}
                                                    Plan Care giver visits as
                                                    you want. You can select
                                                    multiple dates and multiple
                                                    visits per day.
                                                    <br/>
                                                    <br/>
                                                    Mark your dates or set your
                                                    reminders for your caregiver
                                                    session. We have simplified
                                                    our processes to help you
                                                    manage your session the way
                                                    you desire it.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`weekly_selection ${
                                        often == "weekly" ? "show" : ""
                                    }`}
                                >
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="start_date">
                                                    Start Date
                                                </label>
                                                <input
                                                    min={moment().format(
                                                        "YYYY-MM-DD"
                                                    )}
                                                    type="date"
                                                    className="form-control"
                                                    id="start_date"
                                                    value={startDate}
                                                    onChange={(e) =>
                                                        setStartDate(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="end_date">
                                                    End Date
                                                </label>
                                                <input
                                                    min={moment()
                                                        .add(1, "day")
                                                        .format("YYYY-MM-DD")}
                                                    type="date"
                                                    className="form-control"
                                                    id="end_date"
                                                    name={"end_date"}
                                                    value={endDate}
                                                    onChange={(e) =>
                                                        setEndDate(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="select_weekDays">
                                        <div className="headings">
                                            <h5>Select Days For Every week</h5>
                                        </div>
                                        <ul className="days">
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="mon">
                                                        Mon
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "monday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="mon"
                                                        value={"Monday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Monday")}
                                                        onChange={(e) => {
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            );
                                                            // if (
                                                            //     e.target.checked
                                                            // ) {
                                                            //     weeklySchedule[
                                                            //         "Monday"
                                                            //     ] = [
                                                            //         {
                                                            //             start_time:
                                                            //                 "",
                                                            //             end_time:
                                                            //                 "",
                                                            //         },
                                                            //     ];
                                                            // } else {
                                                            //     if (
                                                            //         weeklySchedule[
                                                            //             "Monday"
                                                            //         ]
                                                            //     ) {
                                                            //         delete weeklySchedule[
                                                            //             "Monday"
                                                            //         ];
                                                            //     }
                                                            // }
                                                        }}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="tue">
                                                        Tue
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "tuesday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="tue"
                                                        value={"Tuesday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Tuesday")}
                                                        onChange={(e) =>
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="wed">
                                                        Wed
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "wednesday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="wed"
                                                        value={"Wednesday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Wednesday")}
                                                        onChange={(e) =>
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="thur">
                                                        Thurs
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "thursday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="thur"
                                                        value={"Thursday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Thursday")}
                                                        onChange={(e) =>
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="fri">
                                                        Fri
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "friday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="fri"
                                                        value={"Friday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Friday")}
                                                        onChange={(e) =>
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="sat">
                                                        Sat
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "saturday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="sat"
                                                        value={"Saturday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Saturday")}
                                                        onChange={(e) =>
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <label htmlFor="sun">
                                                        Sun
                                                    </label>
                                                    <input
                                                        disabled={
                                                            selectedServiceSchedule
                                                                ? !selectedServiceSchedule.includes(
                                                                    "sunday"
                                                                )
                                                                : true
                                                        }
                                                        type="checkbox"
                                                        name=""
                                                        id="sun"
                                                        value={"Sunday"}
                                                        checked={Object.keys(
                                                            weeklySchedule
                                                        ).includes("Sunday")}
                                                        onChange={(e) =>
                                                            addSchedule(
                                                                "weekly",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className={`visit_dates ${
                                        often == "one" ? "show" : ""
                                    }`}
                                >
                                    <div className="heading_wrapper">
                                        <h4>Plan Visits for Selected Dates</h4>
                                    </div>
                                    {Object.keys(oneSchedule).map(
                                        (scheduleDate) => {
                                            return (
                                                <div
                                                    key={scheduleDate}
                                                    className="visiting_time"
                                                    id="timing_fields"
                                                >
                                                    <div className="date">
                                                        <h5>
                                                            {moment(
                                                                scheduleDate
                                                            ).format(
                                                                "ddd DD, MMM"
                                                            )}
                                                        </h5>
                                                    </div>
                                                    <div className="row align-items-end">
                                                        {oneSchedule[
                                                            scheduleDate
                                                            ].map(
                                                            (visit, index) => {
                                                                return (
                                                                    <div
                                                                        className="col-md-8"
                                                                        key={index.toString()}
                                                                    >
                                                                        <div className="form-group">
                                                                            <div
                                                                                className="name-wrapper d-flex justify-content-between mb-2">
                                                                                <label>
                                                                                    Select
                                                                                    Time
                                                                                </label>
                                                                                {index >
                                                                                0 ? (
                                                                                    <button
                                                                                        className="close-btn"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            removeVisit(
                                                                                                "one",
                                                                                                scheduleDate,
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={
                                                                                                faClose
                                                                                            }
                                                                                        />
                                                                                    </button>
                                                                                ) : null}
                                                                            </div>
                                                                            <div className="input-group row">
                                                                                <div className="col-md-5">
                                                                                    <p>
                                                                                        Start
                                                                                    </p>
                                                                                    <input
                                                                                        type="time"
                                                                                        className="form-control"
                                                                                        value={
                                                                                            visit.start_time
                                                                                        }
                                                                                        onChange={(
                                                                                            e
                                                                                        ) => {
                                                                                            onStartTimeChange(
                                                                                                "one",
                                                                                                scheduleDate,
                                                                                                index,
                                                                                                e
                                                                                                    .target
                                                                                                    .value
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-2">
                                                                                    <span>
                                                                                        -
                                                                                    </span>
                                                                                </div>

                                                                                <div className="col-md-5">
                                                                                    <p>
                                                                                        End
                                                                                    </p>
                                                                                    <input
                                                                                        type="time"
                                                                                        className="form-control"
                                                                                        value={
                                                                                            visit.end_time
                                                                                        }
                                                                                        onChange={(
                                                                                            e
                                                                                        ) => {
                                                                                            onEndTimeChange(
                                                                                                "one",
                                                                                                scheduleDate,
                                                                                                index,
                                                                                                e
                                                                                                    .target
                                                                                                    .value
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                        <div className="col-md-4">
                                                            <div
                                                                onClick={() =>
                                                                    addMoreVisit(
                                                                        "one",
                                                                        scheduleDate
                                                                    )
                                                                }
                                                                className="add_more"
                                                                id="clone"
                                                            >
                                                                <FontAwesomeIcon
                                                                    className="orange"
                                                                    icon={faAdd}
                                                                />
                                                                <h5>
                                                                    Add More
                                                                    Visits
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                                <div
                                    className={`visit_dates ${
                                        often == "weekly" ? "show" : ""
                                    }`}
                                >
                                    <div className="heading_wrapper">
                                        <h4>Plan Visits for Selected Dates</h4>
                                    </div>
                                    {Object.keys(weeklySchedule).map(
                                        (scheduleDate) => {
                                            return (
                                                <div
                                                    key={scheduleDate}
                                                    className="visiting_time"
                                                    id="timing_fields"
                                                >
                                                    <div className="date">
                                                        <h5>{scheduleDate}</h5>
                                                    </div>
                                                    <div className="row align-items-end">
                                                        {weeklySchedule[
                                                            scheduleDate
                                                            ].map(
                                                            (visit, index) => {
                                                                return (
                                                                    <div
                                                                        className="col-md-8"
                                                                        key={index.toString()}
                                                                    >
                                                                        <div className="form-group">
                                                                            <div
                                                                                className="name-wrapper d-flex justify-content-between mb-2">
                                                                                <label>
                                                                                    Select
                                                                                    Time
                                                                                </label>
                                                                                {index >
                                                                                0 ? (
                                                                                    <button
                                                                                        className="close-btn"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            removeVisit(
                                                                                                "weekly",
                                                                                                scheduleDate,
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={
                                                                                                faClose
                                                                                            }
                                                                                        />
                                                                                    </button>
                                                                                ) : null}
                                                                            </div>
                                                                            {/* <label>
                                                                                Select
                                                                                Time
                                                                            </label> */}
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="time"
                                                                                    className="form-control"
                                                                                    value={
                                                                                        visit.start_time
                                                                                    }
                                                                                    onChange={(
                                                                                        e
                                                                                    ) => {
                                                                                        onStartTimeChange(
                                                                                            "weekly",
                                                                                            scheduleDate,
                                                                                            index,
                                                                                            e
                                                                                                .target
                                                                                                .value
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                <span>
                                                                                    -
                                                                                </span>
                                                                                <input
                                                                                    type="time"
                                                                                    className="form-control"
                                                                                    value={
                                                                                        visit.end_time
                                                                                    }
                                                                                    onChange={(
                                                                                        e
                                                                                    ) => {
                                                                                        onEndTimeChange(
                                                                                            "weekly",
                                                                                            scheduleDate,
                                                                                            index,
                                                                                            e
                                                                                                .target
                                                                                                .value
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                        <div className="col-md-4">
                                                            <div
                                                                onClick={() =>
                                                                    addMoreVisit(
                                                                        "weekly",
                                                                        scheduleDate
                                                                    )
                                                                }
                                                                className="add_more"
                                                                id="clone"
                                                            >
                                                                <FontAwesomeIcon
                                                                    className="orange"
                                                                    icon={faAdd}
                                                                />
                                                                <h5>
                                                                    Add More
                                                                    Visits
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>

                                <div className="about_patient">
                                    <div className="heading_wrapper">
                                        <h4>
                                            Hours Availability
                                        </h4>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className={"badge bg-white shadow rounded px-3 py-2"}>
                                                    {careGiver?.services?.find((val) => val?.service_id == service_id)?.hour_availability || 0}
                                                    {" "}Hours
                                                </label>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="about_patient">
                                    <div className="heading_wrapper">
                                        <h4>
                                            Tell about the patient/child/Senior
                                            (Person who is taking care)
                                        </h4>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>
                                                    Full Name of Client
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Name of Client"
                                                    className="form-control"
                                                    value={fullName}
                                                    onChange={(e) =>
                                                        setFullname(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Gender</label>
                                                <select
                                                    className="form-control"
                                                    value={gender}
                                                    onChange={(e) =>
                                                        setGender(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value={""}>
                                                        Select gender
                                                    </option>
                                                    <option value={"Male"}>
                                                        Male
                                                    </option>
                                                    <option value={"Female"}>
                                                        Female
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Age</label>
                                                <input
                                                    type="number"
                                                    placeholder="Enter Age"
                                                    className="form-control"
                                                    value={age}
                                                    onChange={(e) =>
                                                        setAge(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>
                                                    Write something that helps
                                                    care giver to know about the
                                                    client.
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter the title of the job that defines job in one line"
                                                    className="form-control"
                                                    value={clientIdentity}
                                                    onChange={(e) =>
                                                        setClientIdentity(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-3 alitgn-items-center">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <h4>Job Title</h4>
                                                <input
                                                    type="text"
                                                    placeholder="Enter the title of the job that defines job in one line"
                                                    className="form-control"
                                                    value={title}
                                                    onChange={(e) =>
                                                        setTitle(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <h4>
                                                    Message For Care Giver
                                                    (Description of Job)
                                                </h4>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Write Description of job"
                                                    value={noteText}
                                                    onChange={(e) =>
                                                        setNoteText(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-5 privacy">
                                            <div className="col-md-7">
                                                <div className="form-group privacy_check">
                                                    {/* <input
                                                        type="checkbox"
                                                        className="form-control"
                                                        id="privacy_policy"
                                                    /> */}
                                                    <input
                                                        type="checkbox"
                                                        id="vehicle1"
                                                        name="vehicle1"
                                                        value={agree}
                                                        onChange={(e) =>
                                                            setAgree(
                                                                e.target.checked
                                                            )
                                                        }
                                                        className="mt-2 mr-2"
                                                    ></input>
                                                    <label
                                                        htmlFor="privacy_policy m-0 p-0"
                                                        style={{
                                                            marginTop: "2px",
                                                        }}
                                                    >
                                                        I hereby agree to the{" "}
                                                        {/* <a href="#">
                                                            Terms of Service,
                                                        </a> */}
                                                        <Link to="/privacy-policy">
                                                            Privacy policy
                                                        </Link>{" "}
                                                        {/* &
                                                        <a href="#">
                                                            Refund policy
                                                        </a> */}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="button-group d-flex">
                                                    <button
                                                        className="btn"
                                                        type="button"
                                                        onClick={() =>
                                                            navigate(-1)
                                                        }
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className="btn ml-2"
                                                        type="submit"
                                                    >
                                                        Submit All information
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-3">
                            <div className="profile_sidebar">
                                <div className="care_giver">
                                    <div className="img_box">
                                        <figure>
                                            <img
                                                src={config.returnImage(
                                                    careGiver
                                                )}
                                                alt=""
                                            />
                                        </figure>
                                        <div className="loyalty_tag">
                                            <figure>
                                                <img src={badge} alt=""/>
                                            </figure>
                                        </div>
                                    </div>
                                    <div className="name_rating">
                                        <h4 className="name">
                                            {careGiver.full_name}
                                        </h4>
                                        <h5 className="rating">
                                            <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            {careGiver.rating_by_customer}
                                        </h5>
                                    </div>
                                </div>
                                <div className="contentDv">
                                    <ul className="detailed">
                                        <li>
                                            <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            {careGiver.city +
                                                ", " +
                                                careGiver.state +
                                                " " +
                                                careGiver.zip}
                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-usd"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            $
                                            {
                                                selectedService
                                                    ? selectedService.per_hour
                                                    : ""
                                                // careGiver.services.filter(
                                                //     (service) =>
                                                //         service.service_id ==
                                                //         serviceId
                                                // )[0]["per_hour"]
                                            }{" "}
                                            Per Hour
                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-usd"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Age Range{" : "}
                                            {
                                                selectedService
                                                    ? selectedService.service_for_age
                                                    : ""
                                                // careGiver.services.filter(
                                                //     (service) =>
                                                //         service.service_id ==
                                                //         serviceId
                                                // )[0]["per_hour"]
                                            }{" "}

                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-clock-o"
                                                aria-hidden="true"
                                            ></i>
                                            Average Response Time: 1 Hour
                                        </li>
                                    </ul>
                                    <div className="experienced_box">
                                        <p>{careGiver.bio}</p>
                                    </div>
                                    <div className="cancellation d-none">
                                        <p>
                                            Cancellation Policy is{" "}
                                            <span className="colored">
                                                {
                                                    selectedService
                                                        ? selectedService.cancellation_policy
                                                        : ""
                                                    // careGiver.services.filter(
                                                    //     (service) =>
                                                    //         service.service_id ==
                                                    //         serviceId
                                                    // )[0]["cancellation_policy"]
                                                }{" "}
                                                Days
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {careGiver.lat && careGiver.lng ? (
                                <div className="care_giver_radius mt-5">
                                    <div className="heading">
                                        <h4 className="title">
                                            {careGiver.full_name}'s Radius
                                        </h4>
                                        <p>
                                            Care giver Provide service in this
                                            area
                                        </p>
                                    </div>
                                    <div className="radius_map">
                                        <div
                                            style={{
                                                height: 200,
                                                width: "100%",
                                                position: "relative",
                                            }}
                                        >
                                            <GoogleMapsReact
                                                style={{
                                                    width: "100%",
                                                    height: 200,
                                                }}
                                                bootstrapURLKeys={{
                                                    key: config.mapsApiKey,
                                                }}
                                                center={{
                                                    lat: parseFloat(
                                                        careGiver.lat
                                                    ),
                                                    lng: parseFloat(
                                                        careGiver.lng
                                                    ),
                                                }}
                                                zoom={16}
                                                yesIWantToUseGoogleMapApiInternals
                                                onGoogleApiLoaded={({
                                                                        map,
                                                                        maps,
                                                                    }) => {
                                                    new maps.Marker({
                                                        map,
                                                        position: {
                                                            lat: parseFloat(
                                                                careGiver.lat
                                                            ),
                                                            lng: parseFloat(
                                                                careGiver.lng
                                                            ),
                                                        },
                                                        animation:
                                                        maps.Animation.DROP,
                                                    });
                                                    new maps.Circle({
                                                        strokeWeight: 1,
                                                        strokeColor:
                                                        config.primaryColor,
                                                        strokeOpacity: 0.8,
                                                        fillColor:
                                                        config.primaryColor,
                                                        fillOpacity: 0.3,
                                                        map,
                                                        center: {
                                                            lat: parseFloat(
                                                                careGiver.lat
                                                            ),
                                                            lng: parseFloat(
                                                                careGiver.lng
                                                            ),
                                                        },
                                                        radius: parseFloat(
                                                            careGiver.max_distance
                                                        ),
                                                    });
                                                }}
                                            />
                                        </div>
                                        {/* <GoogleMapsReact
                                            style={{
                                                width: "100%",
                                                height: 200,
                                            }}
                                            bootstrapURLKeys={{
                                                key: config.mapsApiKey,
                                            }}
                                            center={{
                                                lat: parseFloat(careGiver.lat),
                                                lng: parseFloat(careGiver.lng),
                                            }}
                                        /> */}
                                        {/* <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6650771.284398356!2d-112.1702347!3d35.517952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2s!4v1644840610457!5m2!1sen!2s"
                                        width="100%"
                                        height="200"
                                        style={{ border: "0" }}
                                        allowFullScreen=""
                                        loading="lazy"
                                    ></iframe> */}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Hiring Section End Here --> */}
            {/* </div> */}
            <Footer/>
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    services: state.services,
});

const mapDispatchToProps = (dispatch) => ({
    startLoading: () => dispatch({type: START_LOADER}),
    stopLoading: () => dispatch({type:  STOP_LOADER}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hiring);
